$(document).ready(function() {
  const AllPartnersMarqueeGroup = $('.partners-marquee-group');

  AllPartnersMarqueeGroup.on('mouseover', function() {
    pauseAnimation();
  });

  AllPartnersMarqueeGroup.on('mouseout', function() {
    resumeAnimation();
  });

  function pauseAnimation() {
    AllPartnersMarqueeGroup.css('animation-play-state', 'paused');
  }

  function resumeAnimation() {
    AllPartnersMarqueeGroup.css('animation-play-state', 'running');
  }
});







